import { render, staticRenderFns } from "./SaltoSite.vue?vue&type=template&id=7fb68238&"
import script from "./SaltoSite.vue?vue&type=script&lang=ts&"
export * from "./SaltoSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports